import React, {useState} from 'react'
import logo from '../logo.png';
import '../App.css';

import { Link } from "react-router-dom";

// Header Link component
function HeaderLink(props) {
    return (
        <Link to={props.reference} style={props.styles} className="headerLink">{props.text}</Link>
    );
}

function Header() {
    const [currentPath, setCurrentPath] = useState(window.location.pathname);

    if(window.location.pathname === '/just') {
        setCurrentPath('/just')
    }

    return (
        <div>
            <header className="header">
                <Link to="/" style={{ display: 'flex', alignItems: 'center', width: '15%', justifyContent: 'space-between', textDecoration: 'none' }}>
                    <img
                        src={logo}
                        className="App-logo"
                        alt="logo"
                    />
                    <h1 className="appTitle">OohBit</h1>
                </Link>


                <div className='section-header'>
                    <HeaderLink 
                        styles={{
                            backgroundColor: (currentPath === '/company') ? '#444' : '#222'
                        }} 
                        text='Our Company' 
                        reference="/company" 
                    />

                    <HeaderLink 
                        styles={{
                            backgroundColor: (currentPath === '/advertisers') ? '#444' : '#222'
                        }} 
                        text='For Advertisers' 
                        reference="/advertisers" 
                    />

                    {/* <HeaderLink 
                        styles={{
                            backgroundColor: (currentPath === '/contact') ? '#444' : '#222'
                        }} 
                        text='Contact Us' 
                    /> */}
                    <HeaderLink text='EN &#128317;' />
                </div>

            </header>
        </div>
    )
}

export default Header